module.exports = __webpack_public_path__ + "img/znkf.8423609.gif";